import { CANCELATION_REASONS_CATALOGUE } from '../../../../constants'
import { IInvoice, PaymentComplement } from 'models/invoices.models'
import { useCFDIsContainerContext } from 'containers/Invoices/CFDIs/CFDIsContainer/CFDIsContainer'
import SydDialog from 'components/Shared/SydDialog/SydDialog'
import IOCustomForm from 'components/FormComponents/IOComponents/IOCustomForm/IOCustomForm'
import AutocompleteField from 'components/FormComponents/IOComponents/AutocompleteField/AutoCompleteField'
import TextField from 'components/FormComponents/IOComponents/TextField/TextField'
import './styles.scss'

const CancelCFDIForm = () => {
    const {
        activeInvoice,
        cancelCFDIDialogOpen,
        cancelCfdiMutation,
        cancelPaymentComplementMutation,
        cancelReason,
        validDialog,
        selectedCfdiToCancel,
        payComplementListQuery,
        updateState,
    } = useCFDIsContainerContext()

    const typedInvoice = activeInvoice as IInvoice
    const cfdiUuid = selectedCfdiToCancel?.uuid ?? typedInvoice?.uuid

    const isPayComplement = (item: any): item is PaymentComplement => {
        return item?.type === 'payComplement'
    }

    const closeModal = () => {
        updateState(draft => {
            draft.cancelCFDIDialogOpen = false
            draft.validDialog = false
            draft.cancelReason = null
            draft.selectedCfdiToCancel = null
        })
        payComplementListQuery?.refetch()
    }

    return (
        <SydDialog
            open={cancelCFDIDialogOpen}
            className="dialog-invoices cancel-cfdi-form"
            title={
                selectedCfdiToCancel && isPayComplement(selectedCfdiToCancel)
                    ? 'Cancelar Complemento de Pago'
                    : 'Cancelar CFDI'
            }
            subtitle={
                selectedCfdiToCancel && isPayComplement(selectedCfdiToCancel)
                    ? 'Selecciona un motivo de cancelación para este complemento de pago'
                    : 'Selecciona un motivo de cancelación para este CFDI'
            }
            primaryButtonText="Cancelar"
            loadingPrimaryButton={
                cancelCfdiMutation.isLoading || cancelPaymentComplementMutation.isLoading
            }
            disablePrimaryButton={!validDialog}
            secondaryButtonText="Cerrar"
            disableSecondaryButton={
                cancelCfdiMutation.isLoading || cancelPaymentComplementMutation.isLoading
            }
            onCancel={closeModal}
            form="cancelCFDIForm"
            sideButtons
        >
            <IOCustomForm
                id="cancelCFDIForm"
                onSubmit={async (form: any) => {
                    const target = selectedCfdiToCancel ?? typedInvoice
                    if (!target) return

                    const onSuccess = () => closeModal()

                    if (isPayComplement(target)) {
                        cancelPaymentComplementMutation.mutate(
                            {
                                payComplement: target,
                                reason: form.reason.value,
                                substitute: form.substitute,
                            },
                            { onSuccess }
                        )
                    } else {
                        cancelCfdiMutation.mutate(
                            {
                                invoice: typedInvoice,
                                reason: form.reason.value,
                                substitute: form.substitute,
                            },
                            { onSuccess }
                        )
                    }
                }}
                onValidity={v =>
                    updateState(draft => {
                        draft.validDialog = v
                    })
                }
            >
                <TextField
                    name="uuid"
                    label="UUID"
                    value={cfdiUuid}
                    disabled={
                        cancelCfdiMutation.isLoading ||
                        cancelPaymentComplementMutation.isLoading
                    }
                    inputProps={{ readOnly: true }}
                    fullWidth
                    required
                />
                <AutocompleteField
                    name="reason"
                    label="Motivo de Cancelación"
                    catalogue={CANCELATION_REASONS_CATALOGUE}
                    onChange={(v: { label: string; value: number }) =>
                        updateState(draft => {
                            draft.cancelReason = v
                        })
                    }
                    disabled={
                        cancelCfdiMutation.isLoading ||
                        cancelPaymentComplementMutation.isLoading
                    }
                    fullWidth
                    required
                />
                {typedInvoice?.version === '4' && cancelReason?.value === 1 && (
                    <TextField
                        name="substitute"
                        label="Folio de sustitución"
                        fieldType="foil"
                        fullWidth
                        required
                    />
                )}
            </IOCustomForm>
        </SydDialog>
    )
}

export default CancelCFDIForm
